import React from "react";
import { NavLink, Link } from "react-router-dom";
import { BiLogInCircle } from "react-icons/bi";

import "./style.css";


const Navbar = () => {
  
  return (
    <>

      <nav className="navbar navbar-expand-lg bg-white shadow-sm" dir="rtl">
        <div className="container">
          <NavLink className="navbar-brand" to="https://ajyal.areez.co/">
            <img src="logo.png" alt="اجيال" style={{ width: "80px" }} />
          </NavLink>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="d-none d-lg-block">
            <a
              href="#"
              className="nav-link login-button"
              style={{background:"#95c02b"}}
            >
              <BiLogInCircle className="ms-2" />
              النظام 
            </a>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
